module.exports = __webpack_public_path__ + "img/logo_row_write_zh_CN.e62453eb.svg";